import { AppStep } from './reducers/navigation';
import { tryNavigateTo } from './actions/navigation';
import { server } from './utilities/api';
import { resetApp } from './actions';
import _ from 'lodash';

export const isModal = (window.self !== window.top);
const basePath = getBasePath(server); // base path for routes, '' for local, '/booking-staging', and '/booking'

function getBasePath(s) {
  switch (s) {
    case 'local':
      return '';
    case 'staging':
      return '/booking-staging'
    case 'production':
      return '/booking';
    case 'alignet':
      return '/booking-alignet';
    default:
      console.error('No Server Specified!');
      throw new Error('You, again, are not doing this right.')
  }
}

// types for changing url route
export const HOME = 'HOME';
export const LOCATION = 'LOCATION';
export const DATE = 'DATE';
export const SEQUENCES = 'SEQUENCES';
export const STATIONS = 'STATIONS';
export const PARTYROOMS = 'PARTYROOMS';
export const CHECKOUT = 'CHECKOUT';
export const PAY = 'PAY';

export const goRouting = type => { return { type }; }

export const cartEmpty = state => {
  return _.isEmpty(state.station.selectedStations) && _.isEmpty(state.partyRoom.selectedPartyRoom);
}

// checks if path is a valid route on this app
// path: string
export const isValidRoute = path => {
  return (new RegExp([
    '^' + basePath + '/date$',
    '^' + basePath + '/location(/[0-9]+)?$',
    '^' + basePath + '/stations$',
    '^' + basePath + '/partyrooms$',
    '^' + basePath + '/checkout$',
    '^' + basePath + '/pay$',
  ].join('|'), 'i')).test(path);
}

// action.type: { path: url, thunk: function when navigated to path }
export default {
  HOME: { // only used for when testing - ie when 'npm start' it'll auto open up http:localhost:8080/
    path: basePath + '/',
    thunk: async (dispatch, getState) => {
      if (!isModal) {
        dispatch(resetApp());
        dispatch(goRouting(LOCATION));
      }
    }
  },
  BROWSERNOTSUPPORTED: {
    path: basePath + '/BrowserNotSupported'
  },
  LOCATION: {
    path: basePath + '/location/:location_id?',
    thunk: async (dispatch, getState) => {
      if (!isModal) dispatch(tryNavigateTo(AppStep.Location)).catch(error => console.error(error));
    }
  },
  DATE: {
    path: basePath + '/date',
    thunk: async (dispatch, getState) => {
      if (!isModal) {
        const state = getState();
        if (!state.bookingLocation.done) {
            dispatch(resetApp());
            dispatch(goRouting(LOCATION));
        } else dispatch(tryNavigateTo(AppStep.Date)).catch(error => console.error(error));
      }
    }
  },
  SEQUENCES: {
    path: basePath + '/sequences',
    thunk: async (dispatch, getState) => {
      if (!isModal) {
        const state = getState();
        if (!state.bookingLocation.done || !state.date.done) {
          dispatch(resetApp());
          dispatch(goRouting(LOCATION));
        } else dispatch(tryNavigateTo(AppStep.Sequence)).catch(error => console.error(error));
      }
    }
  },
  STATIONS: {
    path: basePath + '/stations',
    thunk: async (dispatch, getState) => {
      if (!isModal) {
        const state = getState();
        if (!state.bookingLocation.done || !state.date.done || !state.sequence.inSequence) {
          dispatch(resetApp());
          dispatch(goRouting(LOCATION));
        } else dispatch(tryNavigateTo(AppStep.Station)).catch(error => console.error(error));
      }
    }
  },
  PARTYROOMS: {
    path: basePath + '/partyrooms',
    thunk: async (dispatch, getState) => {
      if (!isModal) {
        const state = getState();
        if (!state.bookingLocation.done || !state.date.done || !state.sequence.inSequence) {
          dispatch(resetApp());
          dispatch(goRouting(LOCATION));
        } else dispatch(tryNavigateTo(AppStep.PartyRoom)).catch(error => console.error(error));
      }
    }
  },
  CHECKOUT: {
    path: basePath + '/checkout',
    thunk: async (dispatch, getState) => {
      if (!isModal) {
        const state = getState();
        if (!state.bookingLocation.done || !state.date.done || !state.sequence.inSequence || cartEmpty(state)) {
          dispatch(resetApp());
          dispatch(goRouting(LOCATION));
        } else dispatch(tryNavigateTo(AppStep.Checkout)).catch(error => console.error(error));
      }
    }
  },
  PAY: {
    path: basePath + '/pay',
    thunk: async (dispatch, getState) => {
      if (!isModal) {
        const state = getState();
        if (!state.bookingLocation.done || !state.date.done || cartEmpty(state)) {
          dispatch(resetApp());
          dispatch(goRouting(LOCATION));
        } else dispatch(tryNavigateTo(AppStep.Pay)).catch(error => console.error(error));
      }
    }
  }
};
